import { render, staticRenderFns } from "./tabs-body.vue?vue&type=template&id=5fcf56fd&scoped=true&"
import script from "./tabs-body.vue?vue&type=script&lang=js&"
export * from "./tabs-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf56fd",
  null
  
)

export default component.exports